export default {
  notAvailable: 'Not available in the Learning Library',
  available: 'Available in the Learning Library',
};
